import { Component, OnInit } from '@angular/core';
import {exportAktionen, importAktionen} from "../../utils/export/export";
import {Schwimmabzeichen} from "../../models/enums";
import {IconService} from "../../service/icon.service";
import { IAktion } from 'src/app/models/IAktion.interface';
import {AktionService} from "../../service/aktion.service";

enum SaveState{
  READY = "READY",
  SAVING = "SAVING",
  DONE = "DONE",
  ERROR = "ERROR",
  INVALID = "INVALID"
}

@Component({
  selector: 'app-import-aktion',
  templateUrl: './import-aktion.component.html',
  styleUrls: ['./import-aktion.component.scss']
})
export class ImportAktionComponent implements OnInit {

  public aktionen: IAktion[] = [];
  public SaveState = SaveState;
  public saveStates: {state: SaveState, message: string}[] = [];

  constructor(private readonly iconService: IconService,
              private readonly aktionService: AktionService) { }

  get saving(): boolean {
    return this.saveStates.some(v => v.state === SaveState.SAVING);
  }

  get anyReady(): boolean {
    return this.saveStates.some(v => v.state === SaveState.READY);
  }

  ngOnInit(): void {
  }

  downloadVorlage() {
    exportAktionen([{
      titel: "",
      beschreibung: "Max-Alter = 99 bedeutet 'Ab'",
      start: 1641034800000,
      ende: 1641034800000,
      veranstalter: "T.o.J.-Team",
      ort: "",
      preis: 0,
      soziPreis: 1,
      maxKinder: 0,
      minAlter: 6,
      maxAlter: 99,
      schwimmabzeichen: Schwimmabzeichen.KEINS,
      icon: this.iconService.getById(-1),
      aktiv: false,
      anmeldungen: [],
      ausgaben: [],
      id: ''as unknown as number,
      created: 1641034800000,
      edited: 1641034800000,
      mitzubringen: ""
    }])
  }

  async import(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const file: File = inputElement.files[0];
      this.aktionen = (await importAktionen(file)).map(a => {
        if(!a.id){
          return {
            ...a,
            icon: this.iconService.getById(-1),
            anmeldungen: [],
            ausgaben: []
          }
        }
        const tmpA = this.aktionService.getById(typeof a.id === "string" ? parseInt(a.id): a.id);
        if (!tmpA){
          return a;
        }
        return {
          ...a,
          icon: tmpA.icon,
          anmeldungen: tmpA.anmeldungen,
          ausgaben: tmpA.ausgaben
        }
      });
      this.saveStates = this.aktionen.map(a => {
        let found = false;
        for (const s in Schwimmabzeichen){
          if(a.schwimmabzeichen === s){
            found = true;
            break
          }
        }
        if(!found){
          return {state: SaveState.INVALID, message: "Schwimmabzeichen ist falsch"}
        }


        if(!a.anmeldungen){
          return {state: SaveState.INVALID, message: "Anmeldungen wurde nicht gefunden. ID falsch?"}
        }
        return {state: SaveState.READY, message: "Bereit zum Speichern."}
      });
    }
  }

  async saveAll() {
    for (let i = 0; i < this.aktionen.length; i++) {
      if(this.saveStates[i].state === SaveState.READY) {
        await this.saveAktion(i);
      }
    }
  }

  async saveAktion(idx: number) {
    try {
      this.saveStates[idx].state = SaveState.SAVING;
      this.saveStates[idx].message = "Speichern...";
      if (!!this.aktionen[idx].id) {
        await this.aktionService.update(this.aktionen[idx]);
        this.saveStates[idx].message = "Aktualisiert.";
      }else{
        await this.aktionService.create(this.aktionen[idx]);
        this.saveStates[idx].message = "Gespeichert.";
      }
      this.saveStates[idx].state = SaveState.DONE;
    }catch (error){
      this.saveStates[idx].state = SaveState.ERROR;
      this.saveStates[idx].message = "Fehler beim Speichern.";
    }
  }

  exportAktionen(){
    exportAktionen(this.aktionService.getList());
  }
}

